module.exports = __webpack_public_path__ + "static/media/pan.23b81444.png";